import { edit } from "../features/Books/actions";

const editBook = (bookObj) => {
 return async (dispatch) => {
  if (bookObj.id !== undefined) {
   const response = await fetch(`http://localhost:9000/books/${bookObj?.id}`, {
    method: "PUT",
    body: JSON.stringify(bookObj),
    headers: { "Content-Type": "application/json" },
   });
   let book = await response.json();
   dispatch(edit(book));
  }
 };
};
export default editBook;
